import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Check, Clock3, Sparkles } from 'lucide-react';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { servicePackages, addOnServices } from '../data/services';
import { BUSINESS_INFO } from '../utils/constants';
import WhatsAppIcon from '../components/ui/WhatsAppIcon';
import { Link } from 'react-router-dom';
import { binCleaningFeatures } from '../data/binCleaning';

const Services = () => {
  const location = useLocation();
  const [selectedPackage, setSelectedPackage] = useState(null);

  useEffect(() => {
    if (location.state?.selectedPackage) {
      setSelectedPackage(location.state.selectedPackage);
      const element = document.getElementById(location.state.selectedPackage);
      if (element) {
        setTimeout(() => element.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
      }
    }
  }, [location]);

  return (
    <div>
      <section className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <div className="eyebrow">Our Services</div>
            <h1>Professional Valeting Packages</h1>
            <p>
              From essential cleaning to complete detailing — choose the package
              that suits your vehicle and budget.
            </p>
          </div>
        </div>
      </section>

      <section className="section section-dark">
        <div className="container">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
            {servicePackages.map((pkg) => (
              <Card
                key={pkg.id}
                id={pkg.id}
                hover
                className={pkg.popular ? 'popular' : ''}
                style={{
                  borderColor: selectedPackage === pkg.id ? 'var(--gold)' : undefined,
                  boxShadow: selectedPackage === pkg.id ? 'var(--shadow-gold)' : undefined,
                }}
              >
                <div className="service-detail">
                  <div className="service-detail-sidebar">
                    {pkg.popular && (
                      <span className="badge" style={{ marginBottom: '0.875rem', display: 'inline-block' }}>
                        Most Popular
                      </span>
                    )}
                    <h2 style={{ fontSize: '1.75rem', marginBottom: '0.25rem' }}>{pkg.name}</h2>
                    <p className="service-card-tagline">{pkg.tagline}</p>
                    <div className="service-detail-price">{pkg.price}</div>
                    <div className="service-detail-duration">
                      <Clock3 size={16} />
                      <span>{pkg.duration}</span>
                    </div>
                    <a
                      href={BUSINESS_INFO.whatsappLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button variant="whatsapp" className="w-full" icon={WhatsAppIcon}>
                        Book This Package
                      </Button>
                    </a>
                  </div>

                  <div className="service-detail-content">
                    <p style={{ marginBottom: '1.5rem', lineHeight: '1.7', color: 'var(--gray)' }}>
                      {pkg.description}
                    </p>

                    <h3>
                      <Sparkles size={16} />
                      What's Included
                    </h3>
                    <ul className="service-detail-features">
                      {pkg.features.map((feature, idx) => (
                        <li key={idx}>
                          <Check size={18} />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-black">
        <div className="container">
          <div className="section-header">
            <div className="eyebrow">Extras</div>
            <h2>Additional Services</h2>
            <p>Enhance your valeting package with these extra services.</p>
          </div>

          <div className="grid grid-3">
            {addOnServices.map((addon) => (
              <Card key={addon.id} hover className="addon-card">
                <div className="addon-header">
                  <h3 className="addon-name">{addon.name}</h3>
                  <span className="addon-price">{addon.price}</span>
                </div>
                <p className="addon-description">{addon.description}</p>
              </Card>
            ))}
          </div>

{/* ============ BIN CLEANING ============ */}
<section className="section section-black" id="bin-cleaning">
  <div className="container">
    <div className="section-header">
      <div className="eyebrow">Additional Service</div>
      <h2>Professional Bin Cleaning</h2>
      <p>
        Keep your bins clean, fresh and hygienic with ARA's professional bin
        cleaning service. We deep clean, sanitise and deodorise your bins at the
        kerbside, helping reduce unpleasant odours, bacteria and pest problems.
      </p>
    </div>

    <div className="grid grid-4">
      {binCleaningFeatures.map((feature, idx) => {
        const Icon = feature.icon;
        return (
          <Card key={idx} hover className="value-card">
            <div className="value-icon">
              <Icon size={28} />
            </div>
            <h3 style={{ fontSize: '1.0625rem', marginBottom: '0.5rem', color: 'var(--white)' }}>
              {feature.title}
            </h3>
            <p className="value-description">{feature.description}</p>
          </Card>
        );
      })}
    </div>

    <div className="text-center" style={{ marginTop: '3rem' }}>
      <Link to="/pricing#bin-cleaning">
        <Button variant="primary" size="lg">
          View Bin Cleaning Prices
        </Button>
      </Link>
    </div>
  </div>
</section>

          <div className="text-center" style={{ marginTop: '3rem' }}>
            <p style={{ marginBottom: '1.5rem', color: 'var(--gray)' }}>
              Want to customize your service package?
            </p>
            <a href={BUSINESS_INFO.whatsappLink} target="_blank" rel="noopener noreferrer">
              <Button variant="primary" size="lg" icon={WhatsAppIcon}>
                Contact Us for Custom Quote
              </Button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;